import React, { useState, useEffect } from 'react';
import Spin from 'antd/lib/spin';
import { useParams } from 'react-router-dom';
import { getEventsList, getEventFilterOptions, getAlertResolutionsList } from '../../../../API';
import { ActiveAlertsTable } from './components/ActiveAlertsTable';
import { ResolvedAlertsTable } from './components/ResolvedAlertsTable';
import { CSVDownloadModal } from '../CSVDownloadModal';
import { config } from '../../../../config';

import './AlertsOverview.less';

const { REACT_APP_BUILD_ENV } = config;

export const AlertsOverview = (props) => {
  const { theme } = props;
  const { building } = useParams();
  const [activeEvents, setActiveEvents] = useState([]);
  const [resolvedEvents, setResolvedEvents] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [resolutionOptions, setResolutionOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCSVDownloadModalOpen, setIsCSVDownloadModalOpen] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    const filterOptionsFromApi = await getEventFilterOptions(REACT_APP_BUILD_ENV, building);
    const resolutionOptionsFromApi = await getAlertResolutionsList(REACT_APP_BUILD_ENV, false);
    const activeEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, { is_resolved: false });
    const resolvedEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, { is_resolved: true });
    setFilterOptions(filterOptionsFromApi);
    setResolutionOptions(resolutionOptionsFromApi);
    setActiveEvents(activeEventsFromApi.results);
    setResolvedEvents(resolvedEventsFromApi.results);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [building]);

  const renderAlerts = () => {
    return (
      <>
        <div className="alerts-overview-card">
          <ActiveAlertsTable
            activeEvents={activeEvents}
            updateActiveEvents={(updatedEvents) => setActiveEvents(updatedEvents)}
            onDownloadClick={() => setIsCSVDownloadModalOpen(true)}
            theme={theme}
          />
          <ResolvedAlertsTable
            resolvedEvents={resolvedEvents}
            updateResolvedEvents={(updatedEvents) => setResolvedEvents(updatedEvents)}
            filterOptions={filterOptions}
            resolutionOptions={resolutionOptions}
            theme={theme}
          />
        </div>
        {isCSVDownloadModalOpen && (
          <CSVDownloadModal
            filterOptions={filterOptions}
            onCancel={() => setIsCSVDownloadModalOpen(false)}
            theme={theme}
          />
        )}
      </>
    );
  };

  return (
    <div className={`alerts-overview-wrapper alerts-overview-wrapper-${theme}`}>
      {isLoading ? <Spin /> : renderAlerts()}
    </div>
  );
};
